import React from "react"
import {
  LiveScoreEach,
  LiveScorePlayer,
  LiveScoreCash,
  LiveScoreCoef,
} from "../liveScoresComponentsStyles/LiveScoresColumnStyles"
import { numberWithCommas, cashAmount } from "./liveScoresHelper"

interface LiveScoreColumnProps {
  eachUser: {
    type: string
    player_id: string
    name: string
    index: string
    state: number
    bet: number
    coeff: number
    cashout: number
    currency: string
  }
  i?: number
  roundUpdate?: number
  prec: any
}

const LiveScoresColumn = ({ eachUser, i, prec }: LiveScoreColumnProps) => {
  return (
    <LiveScoreEach winner={eachUser.cashout > 0} i={i}>
      <LiveScorePlayer>{eachUser.name}</LiveScorePlayer>
      <LiveScoreCash>
        {eachUser.bet !== 0
          ? cashAmount(eachUser.currency, eachUser.bet, prec)
          : "----"}
      </LiveScoreCash>
      <div>
        <LiveScoreCoef number={eachUser.coeff}>
          {eachUser.coeff > 0 ? eachUser.coeff + "x" : "----"}
        </LiveScoreCoef>
      </div>
      <LiveScoreCash>
        {eachUser.cashout !== 0
          ? numberWithCommas(eachUser.currency, eachUser.cashout.toFixed(prec), prec)
          : "----"}
      </LiveScoreCash>
    </LiveScoreEach>
  )
}

export default LiveScoresColumn
